(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('disponibilidadController', disponibilidadController);

   

    disponibilidadController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'notificationService', 'logEmpleadosService', 'reportingService',
        'endPoints', 'common', 'userService'];


    function disponibilidadController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, notificationService, logEmpleadosService, reportingService, endPoints, common, userService) {

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.changeTab = changeTab;
        vm.expandAll = expandAll;
        vm.goToEdit = goToEdit;
        vm.filterAll = filterAll;
        vm.goToFichajes = goToFichajes; 
        vm.aprobar = aprobar;
        vm.actualize = actualize; 
        vm.aprovacionNum = 0;
        vm.aceptacionNum = 0;
        vm.aprovacionSign = '-';
        vm.pendientesSign = '-';
        vm.expandPendientes = expandPendientes;
        vm.expandAccepted = expandAccepted;
        vm.selectOne = selectOne; 
        vm.goToInforme = goToInforme;
        vm.filterJornadas = filterJornadas; 
        vm.selectAll = selectAll; 


        vm.selectedNum = 0;
        vm.meses = {
            list: [{
                id: 0,
                nombre: 'Enero'
            }, {
                id: 1,
                nombre: 'Febrero'
            }, {
                id: 2,
                nombre: 'Marzo'
            }, {
                id: 3,
                nombre: 'Abril'
            }, {
                id: 4,
                nombre: 'Mayo'
            }, {
                id: 5,
                nombre: 'Junio'
            }, {
                id: 6,
                nombre: 'Julio'
            }, {
                id: 7,
                nombre: 'Agosto'
            }, {
                id: 8,
                nombre: 'Septiembre'
            }, {
                id: 9,
                nombre: 'Octubre'
            }, {
                id: 10,
                nombre: 'Noviembre'
            }, {
                id: 11,
                nombre: 'Diciembre'
            }],
            selected: {
                id: 0,
                nombre: 'Enero'
            }
        };
        vm.anos = {
            list: [],
            selected: 0
        };

        vm.empleados = {
            list: [],
            selected: null
        };

        vm.tabNumber = 1;
        vm.active = [];
        vm.pending = [];
        vm.all = [];
        vm.chargedAll = false;
        vm.supervisor = userService.userData.usuarioId;
        vm.pendingNum = 0;
        vm.loaded = false; 

        (function () {
            loadData();
        })();

        function loadData() {
            if (userService.userData.empresamaster.contrataControlHorario != true) $state.go('flota.controlHorario.activarControlHorario');
            var idx = userService.userData.restrictions.findIndex(x => x.entidad == 'controlHorario');
            if (idx != -1 && (userService.userData.restrictions[idx].tipo & 2) == 2) {
                sendErrorNotification("No tiene los permisos adecuados, consulte con el administrador!");
                $state.go('flota.controlHorario.empleados');
            }
            logEmpleadosService.getAvailable().then(function (response) {
                vm.available = response.data;

            });
            logEmpleadosService.getPending(1).then(function (response) {
                vm.pending = response;
                for (var i = 0; i < vm.pending.length; i++) {
                    vm.pending[i].selected = false;
                }
                vm.aprovacionNum = vm.pending.filter(x => x.estado == 1 || x.estado == 4).length;
                vm.aceptacionNum = vm.pending.filter(x => x.estado == 2).length;

                 if ($stateParams.tabNumber != null || $stateParams.tabNumber != undefined) {
                     vm.changeTab($stateParams.tabNumber);
                 }
                 vm.loaded = true; 
            });
            logEmpleadosService.getPendingNum().then(function (response) {
                vm.pendingNum = response;
            }); 

        }

         function sendErrorNotification(msg) {
             notificationService.sendAppNotification({
                 message: msg,
                 positionY: 'top',
                 positionX: 'right',
                 delay: 3000,
                 type: 'info'
             });
         }

        function actualize() {
            vm.chargedAll = false; 
             loadData();
        }

        function filterAll() {
            if (vm.meses.selected == null || vm.anos.selected == null || vm.empleados.selected == null) {
                sendErrorRequire('Los filtros no están completos!');
            } else {
                var date = new Date(vm.anos.selected.id, vm.meses.selected.id);
                logEmpleadosService.getAccepted(date, vm.empleados.selected.id, 1).then(function (response) {
                    vm.all = response.data;
                    for (var i = 0; i < vm.all.length; i++) {
                        vm.all[i].sign = '-';
                    }

                });
            }
        }

        function sendErrorRequire(messageValue) {
            notificationService.sendAppNotification({
                message: messageValue,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'error'
            });
        }

        function changeTab(idx) {
            vm.tabNumber = idx;
            if (idx == 3 && vm.chargedAll == false) {
                vm.chargedAll = true;
                reportingService.getEmpleados().then(function (result) {
                    vm.empleados.list.push({
                        nombre: 'Todos los empleados',
                        id: '00000000-0000-0000-0000-000000000000'
                    })
                    for (var i = 0; i < result.data.length; i++) {
                        vm.empleados.list.push({
                            nombre: result.data[i].nombre + ' ' + result.data[i].apellidos,
                            id: result.data[i].empleadoId
                        });
                    }
                    vm.empleados.selected = vm.empleados.list[0];
                    setYearsCombo();
                    vm.anos.selected = vm.anos.list.find(x => x.id == ((new Date().getFullYear())));
                    vm.meses.selected = vm.meses.list.find(x => x.id == ((new Date().getMonth() == 0 ? 12 : (new Date().getMonth()-1))));
                    vm.filterAll();
                });
            }
        }

        function setYearsCombo() {
            for (var i = 2016; i < 2100; i++) {
                vm.anos.list.push({
                    id: i,
                    nombre: i.toString()
                });
            }

        }

        function aprobar(item) {
            var lista = [];
            var paprobar = true;
            if (item == null) {
                for (var i = 0; i < vm.pending.length; i++) {
                    if (vm.pending[i].empleado.usuarioId != vm.supervisor) paprobar = false;
                    if (vm.pending[i].selected == true) lista.push(vm.pending[i].registroJornadaId);
                }
            } else {
                if (item.empleado.usuarioId != vm.supervisor) paprobar = false;
                lista.push(item.registroJornadaId);
            }
            if (paprobar) {
                vm.loaded = false; 
                logEmpleadosService.aprobar(lista);
                vm.chargedAll = false;
                loadData();
            } else {
                sendErrorRequire('No tiene permiso para aprobar las jornadas seleccionadas!');

            }

        }

        function goToEdit(item) {

            $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x=> x.title == 'Guardias'), 1);  

            $state.go('flota.controlHorario.detalleJornada', {
                'id': item.registroJornadaId,
                'type': 1,
                'tabNumber': vm.tabNumber
            });

        }

        function goToFichajes() {

            $state.go('flota.fichajes');
        }

         function goToInforme() {
             $state.go('flota.informes.detalle', {
                 'id': 32
             });
         }

        function expandAll(item) {
            if (item.sign == '-') item.sign = '+';
            else item.sign = '-';
        }
        function expandPendientes(idx) {
            if (idx == 1) {
                if (vm.aprovacionSign == '-') {
                    vm.aprovacionSign = '+';
                } else {
                    vm.aprovacionSign = '-';
                }
            } else if (idx == 2) {
                if (vm.pendientesSign == '-') {
                    vm.pendientesSign = '+';
                } else {
                    vm.pendientesSign = '-';
                }
            }
        }

        function expandAccepted(item) {
            if (item.sign == '-') item.sign = '+';
            else item.sign = '-';
        }

        function selectOne(option) {
            if (option.selected == true) {
                option.selected = false;
                vm.selectedNum--;
            } else if (option.selected == false) {
                option.selected = true;
                vm.selectedNum++;
            }

        }

         function selectAll(idx) {
             if (idx == 1) {
                 if (vm.allAprovacion == false) {
                     vm.allAprovacion = true;
                     for (var i = 0; i < vm.pending.length; i++) {
                         if (vm.pending[i].estado == 1 || vm.pending[i].estado == 4) {
                             if (vm.pending[i].selected == false) vm.selectedNum++;
                             vm.pending[i].selected = true;
                         }
                     }
                 } else {
                     vm.allAprovacion = false;
                     for (var i = 0; i < vm.pending.length; i++) {
                         if (vm.pending[i].estado == 1 || vm.pending[i].estado == 4) {
                             if (vm.pending[i].selected == true) vm.selectedNum--;
                             vm.pending[i].selected = false;
                         }
                     }
                 }
             }
         }

         function filterJornadas(item) {
             return item.estado == 1 || item.estado == 4;
         }

    }
})();